import React from 'react';
import CustomIntlProvider from 'components/CustomIntlProvider';
import Navigation from '../Navigation';
import * as styles from './styles.module.scss';

type Props = {
  currentUser: any;
  featureFlags: any;
  messagingChannel: any;
  proUser: any;
};

// TODO - wire up store so we can re-render navigation on client side login see https://alltrails.atlassian.net/browse/GROWTH-572
const DesktopHeader = ({ currentUser, featureFlags, messagingChannel, proUser }: Props) => (
  <CustomIntlProvider>
    <div className={styles.header}>
      <Navigation currentUser={currentUser} featureFlags={featureFlags} messagingChannel={messagingChannel} proUser={proUser} />
    </div>
  </CustomIntlProvider>
);

export default DesktopHeader;
